import { jsx as _jsx } from "react/jsx-runtime";
import { useOutsideClick } from "@/06-shared/lib/useOutsideClick";
import styles from "./index.module.css";
export const DropdownMenu = ({ children, onClose, buttonRef }) => {
    const modalRef = useOutsideClick(() => onClose(), buttonRef);
    return (_jsx("div", Object.assign({ className: styles.window, ref: modalRef }, { children: children })));
};
